import React from "react";

const STAGES = [
  ["01", "Eligibility", "Requests are checked before work begins."],
  ["02", "Direction", "The objective is translated into a structured workflow."],
  ["03", "Policy & budget", "Permissions, cost and quality constraints are evaluated before execution."],
  ["04", "Intelligent routing", "Work is matched to the appropriate capabilities behind the scenes."],
  ["05", "Human review", "The user remains in control before meaningful work moves forward."],
  ["06", "Approved execution", "Approved actions continue through the workspace with context preserved."],
];

export default function SystemArchitecture() {
  return (
    <section id="system" className="z-section" data-testid="system">
      <div className="z-page">
        <div className="max-w-[760px]">
          <p className="z-eyebrow">THE CULMORA SYSTEM</p>
          <h2 className="mt-3 font-display text-[30px] md:text-[42px] leading-[1.08]">Powerful AI work needs more than a prompt.</h2>
          <p className="mt-4 text-[16px] md:text-[18px] leading-[1.65] text-[hsl(var(--z-text-muted))]">Culmora is being built around a controlled path from user objective to approved outcome. Each stage is designed to protect safety, budget, context and human authority.</p>
        </div>
        <ol className="mt-10 grid gap-3 md:grid-cols-2 xl:grid-cols-3">
          {STAGES.map(([n, title, copy]) => (
            <li key={n} className="z-card-system p-5 md:p-6">
              <div className="text-[12px] tracking-[0.18em] text-[hsl(var(--z-teal))]">{n}</div>
              <h3 className="mt-4 font-display text-[20px] md:text-[22px] text-[hsl(var(--z-text))]">{title}</h3>
              <p className="mt-2 text-[15px] leading-[1.6] text-[hsl(var(--z-text-muted))]">{copy}</p>
            </li>
          ))}
        </ol>
        <p className="mt-6 text-[13px] tracking-[0.08em] text-[hsl(var(--z-text-soft))]">Architecture direction · In development</p>
      </div>
    </section>
  );
}
